<template>
  <iframe
    :title="$t('billing.fee-schedule')"
    class="iframe-box"
    :src="url"
    :scrolling="scrolling"
    :style="style"
    :data-e2e="BillingCypressAttribute.checkout.views.FEE_SCHEDULE_IFRAME"
  />
</template>

<script>
import { BillingCypressAttribute } from '@/modules/billing/constants/BillingCypressAttribute';
import { boolToString } from '@/modules/core/app/helpers/StringHelper';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FeeScheduleIFrame',
  props: {
    isClearVault: {
      type: Boolean,
      required: true
    },
    hasScrolling: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: null
    },
    predefinedUrl: {
      type: String,
      default: null
    }
  },
  static: {
    BillingCypressAttribute
  },
  computed: {
    url() {
      if (this.predefinedUrl) {
        return this.predefinedUrl;
      }

      return this.isClearVault
        ? this.$t('billing.planning-scheduling-fee-url')
        : this.$t('billing.settlement-scheduling-fee-url');
    },
    scrolling() {
      return boolToString(this.hasScrolling);
    },
    style() {
      return {
        height: this.height ? `calc(${this.height})` : ''
      };
    }
  }
};
</script>

<style scoped>
.iframe-box {
  width: 100%;
}
</style>
